export default "__VITE_ASSET__b98d9145__"